import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import './polyfills';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { routes } from './app/app-routes';
import { HttpClient, withInterceptorsFromDi, provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { VaultService } from './app/services/vault.service';
import { HttpConfigInterceptor } from './app/services/http-interceptor';
import { registerNotificationActions } from './app/services/notification.initializer';
import { ClearCacheService, clearIndexHtmlCache } from './app/services/clear-cache.service';
import { NotificationStorageService } from './app/services/notification-storage.service';

if (environment.production && environment.envName == 'prod') {
  enableProdMode();
  if (window) {
    // window.console.log = window.console.warn = window.console.info = () => { }
  }
}
export function createTranslateLoader() {
  return new TranslateHttpLoader();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: APP_INITIALIZER, useFactory: registerNotificationActions, multi: true },
    { provide: APP_INITIALIZER, useFactory: clearIndexHtmlCache, deps: [ClearCacheService], multi: true },
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: './assets/i18n/', suffix: '.json' } },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [],
        },
      })
    ),
    VaultService,
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    NotificationStorageService
  ],
});
